import React from 'react';
import { connect } from 'react-redux';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';
import { closeRenewalWizard } from '../store/actions';

import Wizard from 'components/ui/Wizard/Wizard';
import FetchProposals from './pages/FetchProposals';
import SelectRenewal from './pages/SelectRenewal';
import LengthOfLease from './pages/LengthOfLease';
import ReviewRenewalDetails from './pages/ReviewRenewalDetails';
import AssignLeaseHolders from './pages/AssignLeaseHolders';
import SubmitRenewal from './pages/SubmitRenewal';

const wizardPages = [
  {
    component: props => <FetchProposals {...props} />,
  },
  {
    component: props => <SelectRenewal {...props} />,
  },
  {
    component: props => <LengthOfLease {...props} />,
  },
  {
    component: props => <ReviewRenewalDetails {...props} />,
  },
  {
    component: props => <AssignLeaseHolders {...props} />,
  },
  {
    component: props => <SubmitRenewal {...props} />,
  },
];

const RenewalContainer = ({ showRenewalWizard, closeRenewalWizard, ...rest }) => (
  <RenderIfToggleOn toggle="yardi_renewals" dontRenderIf={!showRenewalWizard}>
    <Wizard
      showWizard={showRenewalWizard}
      closeWizard={closeRenewalWizard}
      wizardPages={wizardPages}
      componentWidth="62.5%"
      {...rest}
    />
  </RenderIfToggleOn>
);

const mapStateToProps = store => ({
  showRenewalWizard: store.landlord.renewals.showRenewalWizard,
  leaseId: store.landlord.renewals.leaseId,
});

const mapDispatchToProps = {
  closeRenewalWizard,
};

export default connect(mapStateToProps, mapDispatchToProps)(RenewalContainer);
